<fin-corporate-passenger-search
  *ngIf="isCorporateAdminOrTravelBooker$ | async"
  [corporateUsers$]="corporateUsers$"
  [passengerFormGroup]="passengerFormGroup"
  (userSelected)="selectCorporateUser($event)"
  (userCleared)="corporateUserCleared.emit($event)"
  (toggleLoader)="showLoader$.next($event)"
/>

<div class="absolute fill grow z1 loader-container pr-large-t" *ngIf="showLoader$ | async" #loaderContainer>
  <fcom-loader [loaderType]="LoaderTheme.INLINE" />
</div>

<div class="flex flex--column">
  <div class="gender pr-xsmall-t">
    @if (passengerFormGroup.contains(FIELDS.gender)) {
      <fcom-radio-item-group
        [options]="GENDER_OPTIONS"
        [controlName]="FIELDS.gender"
        [name]="'gender-' + groupIndex"
        [translationPrefix]="'paxDetails.fields.gender'"
        [parentForm]="passengerFormGroup"
        [theme]="RadioButtonTheme.BOX"
        [helperText]="true"
        [isRequired]="true"
      />
    }
  </div>
  <div class="flex name-wrapper">
    <fcom-text-input
      *ngFor="let inputName of [FIELDS.firstName, FIELDS.lastName]"
      class="input-name block ms-small-t flex-1 flex--basis0"
      [class.is-hidden]="hideDisabledFields && passengerFormGroup.get(inputName)?.disabled"
      [required]="true"
      [parentForm]="passengerFormGroup"
      [displayMargin]="false"
      [translationPrefix]="'paxDetails.fields.' + inputName"
      [controlName]="inputName"
      [id]="inputName + '-' + groupIndex"
      [placeHolder]="'paxDetails.fields.' + inputName + '.placeholder'"
      [displayMargin]="false"
      [attr.data-testid]="inputName + '-' + groupIndex"
      [tooltipHeading]="'paxDetails.fields.' + inputName + '.tooltipHeading' | finLocalization"
      [tooltipContent]="'paxDetails.fields.' + inputName + '.tooltipContent' | finLocalization"
    />
  </div>
</div>

<ng-template #emailAndPhoneNumber>
  <div
    [attr.data-testid]="'copy-from-' + groupIndex"
    class="nordic-blue-25-bg surface-secondary ps-xsmall-y rounded-large"
    *ngIf="copyFromPassengers.length > 0"
  >
    <div class="ps-small">
      <p class="font-body-1 nordic-blue-400-text text-icon-secondary bold-type ps-medium-b font-body-medium-bold">
        {{ 'paxDetails.copyFrom.title' | finLocalization }}
      </p>

      <fin-select-input
        [attr.data-testid]="'form-field-copyFromPassengers-' + groupIndex"
        [controlName]="'copyFromPassengers'"
        [translationPrefix]="'paxDetails.copyFrom'"
        [selectLabelTranslationKey]="'paxDetails.copyFrom.default'"
        [parentForm]="copyFromPassengerGroup"
        [required]="false"
        [options]="copyFromPassengers"
        [displayMargin]="false"
      />
    </div>
  </div>

  <fcom-text-input
    [attr.data-testid]="'pax-details-email-' + groupIndex"
    *ngIf="passengerFormGroup.get(FIELDS.type).value !== FinnairPassengerCode.INF"
    class="block ms-small-t flex-1"
    [parentForm]="passengerFormGroup"
    [displayMargin]="false"
    [translationPrefix]="'paxDetails.fields.email'"
    [controlName]="FIELDS.email"
    [id]="'email-' + groupIndex"
    [placeHolder]="'paxDetails.fields.email.placeholder'"
    [inputType]="InputType.EMAIL"
    data-hj-suppress
    data-dd-privacy="hidden"
  />

  <fin-form-array
    [attr.data-testid]="'pax-details-phones-' + groupIndex"
    *ngIf="
      passengerFormGroup.get(FIELDS.phones) && passengerFormGroup.get(FIELDS.type).value !== FinnairPassengerCode.INF
    "
    [parentForm]="passengerFormGroup"
    [controlName]="'phones'"
    [translationPrefix]="'paxDetails.fields.phones'"
    [displayLabels]="false"
    [minGroups]="1"
    [maxGroups]="3"
    [hideGroups]="hideGroups"
    [displayContainerStyles]="false"
    [compressedList]="true"
    [formGroupConfig]="phoneNumbersGroupConfig"
    [formGroupOptions]="phoneGroupOptions"
    [disabled]="passengerFormGroup.get(FIELDS.phones)?.disabled"
  >
    <ng-template let-otherPhone="parentFormGroup" let-index="index">
      <fin-form-group
        class="block field wd-phone ms-small-t"
        [group]="otherPhone"
        [translationPrefix]="'paxDetails.fields'"
        [attr.data-index]="index"
        [names]="[FIELDS.phonePrefix, FIELDS.phoneNumber]"
        [showOnlyGroupLevelErrors]="true"
      >
        <div class="phone-wrapper flex">
          <fin-select-input
            class="input-phone flex-1 flex--basis0"
            [controlName]="FIELDS.phonePrefix"
            [id]="'tel-country-code-' + groupIndex"
            [translationPrefix]="'paxDetails.fields.phonePrefix'"
            [parentForm]="otherPhone"
            [displayMargin]="false"
            [options]="phonePrefixes$ | async"
          />
          <fcom-text-input
            class="flex-1 flex--basis0"
            [translationPrefix]="'paxDetails.fields.phoneNumber'"
            [controlName]="FIELDS.phoneNumber"
            [id]="'tel-national-' + groupIndex"
            [parentForm]="otherPhone"
            [displayMargin]="false"
            [placeHolder]="'paxDetails.fields.phoneNumber.placeholder'"
            [inputType]="InputType.NUMBER"
            data-hj-suppress
            data-dd-privacy="hidden"
          />
        </div>
      </fin-form-group>
    </ng-template>
  </fin-form-array>

  <fin-form-group
    [attr.data-testid]="'pax-details-phone-' + groupIndex"
    *ngIf="
      passengerFormGroup.get(FIELDS.phone) && passengerFormGroup.get(FIELDS.type).value !== FinnairPassengerCode.INF
    "
    class="block field wd-phone"
    [group]="passengerFormGroup.get(FIELDS.phone)"
    [translationPrefix]="'paxDetails.fields'"
    [names]="[FIELDS.phonePrefix, FIELDS.phoneNumber]"
    [showOnlyGroupLevelErrors]="true"
  >
    <div class="phone-wrapper flex">
      <fin-select-input
        class="input-phone flex-1 flex--basis0 ms-small-t"
        [controlName]="FIELDS.phonePrefix"
        [id]="'tel-country-code-' + groupIndex"
        [translationPrefix]="'paxDetails.fields.phonePrefix'"
        [parentForm]="passengerFormGroup.get(FIELDS.phone)"
        [displayMargin]="false"
        [options]="phonePrefixes$ | async"
        [required]="isMainPassenger"
        [attr.aria-required]="isMainPassenger"
        [selectLabelTranslationKey]="'paxDetails.fields.phonePrefix.placeholder'"
      />

      <fcom-text-input
        class="flex-1 flex--basis0 ms-small-t"
        [controlName]="FIELDS.phoneNumber"
        [id]="'tel-national-' + groupIndex"
        [translationPrefix]="'paxDetails.fields.phoneNumber'"
        [parentForm]="passengerFormGroup.get(FIELDS.phone)"
        [displayMargin]="false"
        [required]="isMainPassenger"
        [placeHolder]="'paxDetails.fields.phoneNumber.placeholder'"
        (inputEvent)="removeLeadingZero($event)"
      />
    </div>
    <cms-unstyled-fragment
      *ngIf="'fragments.optOutTelephoneSolicitation.url' | finLocalization"
      class="block font-body-1 mr-large-t font-body-medium"
      [contentUrl$]="'fragments.optOutTelephoneSolicitation.url' | finLocalization | finToObservable"
    />
  </fin-form-group>

  <div
    [attr.data-testid]="'copy-to-all-passengers-' + groupIndex"
    class="nordic-blue-25-bg surface-secondary flex flex--left-center copy-details ms-xsmall-t ps-small rounded-large"
    *ngIf="showCopyDetailsButton"
  >
    <fcom-button
      (clickBtn)="copyDetailsClicked.emit()"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [text]="'paxDetails.copyDetailsToAll.button' | finLocalization"
      [aria]="{
        disabled:
          passengerFormGroup.disabled || !passengerFormGroup.valid || !passengerFormGroup.get(FIELDS.email).value,
      }"
    />
    <div class="font-body-1 font-body-medium">{{ 'paxDetails.copyDetailsToAll.info' | finLocalization }}</div>
  </div>
</ng-template>

<fin-form-group
  *ngIf="passengerFormGroup.get(FIELDS.birthDate) !== null"
  class="block field wd-birthDay pr-xsmall-y"
  [class.is-hidden]="hideDisabledFields && passengerFormGroup.get(FIELDS.birthDate)?.disabled"
  [group]="passengerFormGroup.get(FIELDS.birthDate)"
  [translationPrefix]="'paxDetails.fields'"
  [groupTranslationPrefix]="'paxDetails.fields.birthDate'"
  [required]="true"
  [names]="[FIELDS.dateOfBirth, FIELDS.monthOfBirth, FIELDS.yearOfBirth]"
  [showOnlyGroupLevelErrors]="true"
>
  <div class="title font-body-1 nordic-blue-900 font-body-medium">
    {{ 'paxDetails.dateOfBirthLabel' | finLocalization }}
  </div>
  <div class="birthday-wrapper flex">
    <fin-select-input
      class="bday-day flex-1 flex--basis0 ms-small-t"
      data-field="bday-day"
      [controlName]="FIELDS.dateOfBirth"
      [id]="'bday-day-' + groupIndex"
      [translationPrefix]="'paxDetails.fields.dateOfBirth'"
      [parentForm]="passengerFormGroup.get(FIELDS.birthDate)"
      [displayMargin]="false"
      [options]="dayOptions$ | async"
    />

    <fin-select-input
      class="bday-month flex-1 flex--basis0 ms-small-t"
      data-field="bday-month"
      [controlName]="FIELDS.monthOfBirth"
      [id]="'bday-month-' + groupIndex"
      [translationPrefix]="'paxDetails.fields.monthOfBirth'"
      [parentForm]="passengerFormGroup.get(FIELDS.birthDate)"
      [displayMargin]="false"
      [options]="monthOptions"
    />

    <fin-select-input
      class="flex-1 flex--basis0 ms-small-t"
      data-field="bday-year"
      [controlName]="FIELDS.yearOfBirth"
      [id]="'bday-year-' + groupIndex"
      [translationPrefix]="'paxDetails.fields.yearOfBirth'"
      [parentForm]="passengerFormGroup.get(FIELDS.birthDate)"
      [displayMargin]="false"
      [options]="yearOptions"
    />
  </div>
</fin-form-group>

<ng-container *ngIf="!isMainPassenger && passengerFormGroup.get(FIELDS.type).value !== FinnairPassengerCode.INF">
  <fcom-button
    *ngIf="!showContactDetails"
    [attr.data-testid]="'contact-details-button-' + groupIndex"
    class="ps-small-t"
    [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
    [text]="'paxDetails.addContactDetails.title' | finLocalization"
    [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.LEFT }"
    [type]="ButtonType.BUTTON"
    (clickBtn)="showContactDetailsFields()"
    [attr.aria-label]="'paxDetails.addContactDetails.description' | finLocalization"
  />
</ng-container>

<ng-container *ngIf="showContactDetails || isMainPassenger">
  <ng-container *ngTemplateOutlet="emailAndPhoneNumber" />
</ng-container>

@let canShowJoinFFSection = isMainPassenger && shouldShowJoinFinnairPlusSection && (profileType$ | async) === undefined;

@if (showSingleFFCardSection()) {
  @if (canShowPaxExistingFFSection || canShowJoinFFSection) {
    <div
      class="title font-body-1 bold-type nordic-blue-900 pr-xsmall-t font-body-medium-bold"
      [attr.data-testid]="'frequent-flyer-section-' + groupIndex"
    >
      {{ 'paxDetails.frequentFlyerSection.title' | finLocalization }}
    </div>
  }
  @if (canShowPaxExistingFFSection) {
    <fin-form-group
      [attr.data-testid]="'add-frequent-flyer-details-' + groupIndex"
      class="block frequent-flyer field pr-xsmall-y"
      [group]="passengerFormGroup.get(FIELDS.frequentFlyerCard)"
      [translationPrefix]="'paxDetails.fields'"
      [groupTranslationPrefix]="'paxDetails.fields.cardNumber'"
      [required]="false"
      [names]="[FIELDS.companyCode, FIELDS.cardNumber]"
      [showOnlyGroupLevelErrors]="true"
    >
      <fcom-checkbox-input
        class="ms-large-b"
        [theme]="CheckBoxTheme.ROUNDED"
        [parentForm]="frequentFlyerToggleForm"
        [controlName]="'toggle'"
      >
        <div class="flex flex--column">
          <span
            class="flex flex--column font-body-1 medium-type privatedata font-label-medium"
            data-hj-suppress
            data-dd-privacy="hidden"
          >
            {{ 'paxDetails.fields.frequentFlyerCard.title' | finLocalization }}
          </span>
          @if ((frequentFlyerIsOpen$ | async) === false) {
            <span
              class="font-body-2 light-type grey-600-text text-icon-secondary privatedata font-body-small"
              data-hj-suppress
              data-dd-privacy="hidden"
            >
              {{ 'paxDetails.fields.frequentFlyerCard.label' | finLocalization }}
            </span>
          }
        </div>
      </fcom-checkbox-input>
      @if ((frequentFlyerIsOpen$ | async) === true) {
        <div class="frequent-flyer-wrapper flex">
          <fin-select-input
            class="frequent-flyer-airline flex-1 flex--basis0 ms-small-t"
            [translationPrefix]="'paxDetails.fields.companyCode'"
            [controlName]="FIELDS.companyCode"
            [id]="'frequent-flyer-airline-' + groupIndex"
            [parentForm]="passengerFormGroup.get(FIELDS.frequentFlyerCard)"
            [displayMargin]="false"
            [options]="frequentFlyerAirlines$ | async"
            [selectLabelTranslationKey]="'paxDetails.fields.companyCode.placeholder'"
          />
          <fcom-text-input
            class="flex-1 flex--basis0 ms-small-t"
            [translationPrefix]="'paxDetails.fields.cardNumber'"
            [controlName]="FIELDS.cardNumber"
            [id]="'frequent-flyer-number-' + groupIndex"
            [parentForm]="passengerFormGroup.get(FIELDS.frequentFlyerCard)"
            [displayMargin]="false"
            [finElemTracker]="'frequent-flyer-number'"
            [finElemType]="ElementTypes.INPUT"
            [finElemContext]="trackingContext + '_pax-details'"
            [placeHolder]="'paxDetails.fields.cardNumber.placeholder'"
          />
        </div>
      }
    </fin-form-group>
  }

  @if (canShowJoinFFSection) {
    <fcom-checkbox-input
      [attr.data-testid]="'join-finnair-plus-' + groupIndex"
      class="ms-large-y"
      [parentForm]="passengerFormGroup"
      [controlName]="FIELDS.joinFinnairPlus"
      [finElemTracker]="'join-finnair-plus'"
      [finElemContext]="'booking-flow_pax-details'"
      [finElemType]="C.ElementTypes.CHECKBOX"
      (change)="toggleJoinFinnairPlus()"
    >
      <div class="flex flex--column">
        <span class="font-body-1 medium-type privatedata font-label-medium" data-hj-suppress data-dd-privacy="hidden">
          {{ 'paxDetails.fields.joinFinnairPlus.title' | finLocalization }}
        </span>
        <span
          class="font-body-2 light-type grey-600-text text-icon-disabled-text privatedata font-body-small"
          data-hj-suppress
          data-dd-privacy="hidden"
        >
          {{ 'paxDetails.fields.joinFinnairPlus.label' | finLocalization }}
        </span>
      </div>
    </fcom-checkbox-input>
  }
} @else if (!hideFrequentFlyerSection() && allowMultipleFFCards) {
  <h3 class="font-body-1 nordic-blue-900-text text-icon-primary mr-small-t font-body-medium">
    {{ 'paxDetails.frequentFlyerDetails' | finLocalization }}
  </h3>
  <p class="mr-xsmall-t mr-xsmall-b">{{ 'paxDetails.frequentFlyerHelp' | finLocalization }}</p>
  <fin-form-array
    [parentForm]="passengerFormGroup"
    [controlName]="'frequentFlyerCards'"
    [translationPrefix]="'paxDetails.fields.frequentFlyerCards'"
    [displayLabels]="false"
    [minGroups]="1"
    [maxGroups]="3"
    [hideGroups]="hideGroups"
    [displayContainerStyles]="false"
    [compressedList]="true"
    [disabled]="passengerFormGroup.get(FIELDS.frequentFlyerCards)?.disabled"
    [formGroupConfig]="frequentFlyerGroupConfig"
    [formGroupOptions]="frequentFlyerGroupOptions"
  >
    <ng-template let-otherCard="parentFormGroup" let-index="index">
      <fin-form-group
        class="block frequent-flyer-multiple field pr-xsmall-b"
        [attr.data-index]="index"
        [group]="otherCard"
        [translationPrefix]="'paxDetails.fields'"
        [groupTranslationPrefix]="'paxDetails.fields.cardNumber'"
        [required]="false"
        [names]="[FIELDS.companyCode, FIELDS.cardNumber]"
        [showOnlyGroupLevelErrors]="true"
      >
        <div class="frequent-flyer-wrapper flex">
          <fin-select-input
            class="frequent-flyer-airline flex-1 flex--basis0 ms-small-t"
            [translationPrefix]="'paxDetails.fields.companyCode'"
            [controlName]="FIELDS.companyCode"
            [id]="'frequent-flyer-airline-' + groupIndex"
            [parentForm]="otherCard"
            [displayMargin]="false"
            [options]="frequentFlyerCardOptions$ | finMap: '' + index | async"
          />
          <fcom-text-input
            class="flex-1 flex--basis0 ms-small-t"
            [translationPrefix]="'paxDetails.fields.cardNumber'"
            [controlName]="FIELDS.cardNumber"
            [id]="'frequent-flyer-number-' + groupIndex"
            [parentForm]="otherCard"
            [displayMargin]="false"
            [finElemTracker]="'frequent-flyer-number'"
            [finElemType]="ElementTypes.INPUT"
            [finElemContext]="trackingContext + '_pax-details'"
          />
        </div>
      </fin-form-group>
    </ng-template>
  </fin-form-array>
}

<div class="mandatory font-body-1 dark-grey ms-xsmall-t flex flex--end font-body-medium">
  {{ 'paxDetails.mandatory' | finLocalization }}
</div>
